// ----------------------------------------------------------------------------
// Template: Order
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/hero/hero';

// Styles
import './_order.scss';